module.exports = __webpack_public_path__ + "img/strelki.2bde288e.png";